export default [
  {
    id: 1,
    authoravatar: "https://www.acadecraft.com/favicon.gif",
    authorName: "Acadcraft Private Limited", // author Name
    authorRole: "", // author Role
    time: "7:28:39 pm",         // Project Name
    action: "Added",    
    object: "Project",    // Project Role
    memberavatar: "https://i.pravatar.cc/150?img=12", 
    memberName: 'Vansh Saini', // member Name
    memberRole: 'Social Media Strategist',  // member role
    details: 'Members were added to "Project Coordinator" project with "Manager" role', 
  },
  {
    id: 2,
    authoravatar: "https://i.pravatar.cc/150?img=13",
    authorName: "Dianne Russell", // author Name
    authorRole: "SEO Specialist", // author Role
    time: "7:28:39 pm",         // Project Name
    action: "Created",    
    object: "Project",    // Project Role
    memberavatar: "https://i.pravatar.cc/150?img=14", 
    memberName: 'Vansh Saini', // member Name
    memberRole: 'Social Media Strategist',  // member role
    details: 'Members were added to "Project Coordinator" project with "Manager" role', 
  },
  {
    id:3,
    authoravatar: "",
    authorName: "", // author Name
    authorRole: "", // author Role
    time: "7:28:39 pm",         // Project Name
    action: "Invite",    
    object: "Member setting",    // Project Role
    memberavatar: "https://i.pravatar.cc/150?img=15", 
    memberName: 'Vansh Saini', // member Name
    memberRole: 'Social Media Strategist',  // member role
    details: 'Members were added to "Project Coordinator" project with "Manager" role', 
  },
   
];
